<h2 mat-dialog-title class="dialog-header">
  {{ data.title }} <mat-icon *ngIf="data.universityCountryDetails" style="margin-left: 20px;" [matTooltip]="data.universityCountryDetails">school</mat-icon> <mat-icon *ngIf="data.universityName" style="margin-left: 6px;" [matTooltip]="data.universityName">account_balance</mat-icon><mat-icon *ngIf="data.intakeDetails" style="margin-left: 6px;" [matTooltip]="data.intakeDetails">access_time</mat-icon>
</h2>
<span mat-dialog-close class="btn-mat-dialog-close">
    <img src="assets/images/close-icon-gray.svg" alt="Close" title="Close" (click)="markAsRead()"/>
</span>

<ng-container>
  <mat-dialog-content class="dialog-content">
    <div [innerHTML]="data.description"></div>
    @if(data.imagePath){
      <img [src]="fileUrl + data.imagePath" >
    }    
  </mat-dialog-content>

  <mat-dialog-actions align="end" class="dialog-footer">
    <a mat-button mat-dialog-close (click)="markAsRead()">Mark As Read</a>
  </mat-dialog-actions>
</ng-container>
